import React, { FC } from 'react';
import { format } from 'date-fns';
import { Link } from 'react-router-dom';
import { ListItem, ListItemAvatar, Avatar, ListItemText } from '@material-ui/core';

import { getLetterForAvatar, clipName, intl } from 'helpers';
import { routes } from 'router/routesList';

import { useStyles } from './styles';

const { REACT_APP_AWSS3_URL_IMAGE_BEG } = process.env;

type Props = {
  id: string;
  avatar: string | null;
  firstName: string;
  lastName: string;
  joinedAt: string;
};

const TalentListItem: FC<Props> = ({ id, avatar, firstName, lastName, joinedAt }) => {
  const styles = useStyles();

  return (
    <ListItem className={styles.item} component={Link} to={`/${routes.BRAND}/${routes.TALENT}/${id}`}>
      <ListItemAvatar>
        <Avatar className={styles.avatar} src={REACT_APP_AWSS3_URL_IMAGE_BEG + avatar}>
          {getLetterForAvatar(firstName, lastName)}
        </Avatar>
      </ListItemAvatar>
      <ListItemText
        classes={{ primary: styles.primaryText, secondary: styles.secondaryText }}
        primary={clipName(firstName, lastName, 28)}
        secondary={`${intl('SHARED.joined')} ${format(new Date(joinedAt), 'MMM d, yyyy')}`}
      />
    </ListItem>
  );
};

export { TalentListItem };
